<template>
  <div class="ibox float-e-margins">
    <registrar-header></registrar-header>
    <registrar-content></registrar-content>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from './Registrar/Header'
import Content from './Registrar/Content'

export default {
  computed: {
    ...mapGetters({
      user: 'getUser',
      registrars: 'getRegistrars'
    }),
    registrar: ({ $route, $store }) => $store.state.registrarList.find(r => r.id === parseInt($route.params.id)) || {}
  },
  components: {
    registrarHeader: Header,
    registrarContent: Content
  },
  mounted () {
    this.$store.state.registrarList.length === 0 && this.$store.dispatch('loadRegistrars')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Accounts/Registrar.vue